

  //If sepia cookie set as true then add sepia
  if ( Cookies.get('sepiaoff') ) {
    $('body').removeClass('sepia');
    $('#aprilfoolsbtn').addClass('nofool');
  }

  //On click of april button check the cookies
  $('#aprilfoolsbtn').click(function(e){
    //run the april fool toggle
    if ( Cookies.get('sepiaoff') ) {
      Cookies.remove('sepiaoff', 'active');
    }else {
      Cookies.set('sepiaoff', 'active');
    }

    aprilFoolToggle();
    e.preventDefault();
  });

  function aprilFoolToggle() {
    if ( $('body').hasClass('sepia') ) {
      $('#aprilfoolsbtn').addClass('nofool');
      $('body').removeClass('sepia');
    } else {
      $('#aprilfoolsbtn').removeClass('nofool');
      $('body').addClass('sepia');
    }
  }



// WEBPACK FOOTER //
// ./src/js/aprilFools.js